import { RundotGameAPI } from '../rundot-game-api/types'
import { defaultPackBaseUrl, type AssetLibraryApi } from './AssetLibraryApi'

export class MockAssetLibraryApi implements AssetLibraryApi {
  private readonly rundotGameApi: RundotGameAPI

  constructor(rundotGameApi: RundotGameAPI) {
    this.rundotGameApi = rundotGameApi
  }

  async getPackBaseUrl(packId: string, version: string): Promise<string> {
    return defaultPackBaseUrl(packId, version)
  }

  async loadAssetsBundle(game: string, bundleKey: string, fileType: string = 'stow'): Promise<ArrayBuffer> {
    const blob = await this.rundotGameApi.cdn.fetchFromCdn(`${game}/${bundleKey}.${fileType}`)
    return await blob.arrayBuffer()
  }
}
